/**
 * @Author: v_jppjpeng
 * @Date: 2024-10-31 10:11:55
 * @Explain: 获取数据状态不同展示
 */

import { DefaultPage } from '@/components/tdesign';
import { intlGet } from '@/locales';
import { useCallback } from 'react';
// type
import { StatusTipEnum } from '@/definition/common/data.d';
import { DefaultPageStatusEnum } from '../data.d';

type PropsType = {
  status: StatusTipEnum;
  column?: 'block' | 'inline';
  onRetry?: () => void;
};

function StatusTips(props: PropsType) {
  const { status, column, onRetry } = props;

  const onRender = useCallback(() => {
    switch (status) {
      case StatusTipEnum.loading:
        return (
          <DefaultPage column={column} status={DefaultPageStatusEnum.LOADING} />
        );
      case StatusTipEnum.empty:
        return (
          <DefaultPage column={column} status={DefaultPageStatusEnum.NO_DATA} />
        );
      case StatusTipEnum.noMore:
        return (
          <DefaultPage
            column={column}
            status={DefaultPageStatusEnum.NO_DATA}
            textContent={intlGet('COMMON.NO.MORE.DATA')}
          />
        );
      case StatusTipEnum.error:
        return (
          <DefaultPage
            column={column}
            status={DefaultPageStatusEnum.NO_NETWORK}
            onRetry={onRetry}
          />
        );
    }
  }, [status, column, onRetry]);
  return onRender();
}

export default StatusTips;
